import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import {
  forgotPasswordReducer,
  profileReducer,
  getAllUser,
  userReducers,
  updateUserRole,
} from "./reducers/userReducers";
import {
  myComplaintsReducer,
  adminComplaintsReducer,
  storeComplaintsReducer,
} from "./reducers/complaintReducer";
import {
  createBlogReducer,
  getAllBlogsReducer,
  getBlogDetailsReducer,
} from "./reducers/blogReducer";
import {
  storeAuthReducer,
  createStoreReducer,
  storeListReducer,
} from "./reducers/storeReducer";

const reducer = combineReducers({
  user: userReducers,
  storeAuth: storeAuthReducer,
  // storeAuthReducer,
  profile: profileReducer,
  allUser: getAllUser,
  userRole: updateUserRole,
  forgotPassword: forgotPasswordReducer,
  myComplaints: myComplaintsReducer,
  adminComplaints: adminComplaintsReducer,
  storeComplaints: storeComplaintsReducer,
  createBlog: createBlogReducer,
  allBlogs: getAllBlogsReducer,
  blogDetails: getBlogDetailsReducer,
  storeList: storeListReducer,
  createStore: createStoreReducer,
});

const middleware = [thunk];

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
